export class OrderPartAdd {

    id?: number;
    name?: string;
    price_adapt?: number;
    product_id?: number;

    constructor() {}
  }
